<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <FormulateSlot name="prefix" :context="context">
      <component
        :is="context.slotComponents.prefix"
        v-if="context.slotComponents.prefix"
        :context="context"
      />
    </FormulateSlot>
    <input
      type="text"
      v-model="context.model"
      v-bind="context.attributes"
      @blur="context.blurHandler"
    />
    <FormulateSlot name="suffix" :context="context">
      <component
        :is="context.slotComponents.suffix"
        v-if="context.slotComponents.suffix"
        :context="context"
      />
    </FormulateSlot>
  </div>
</template>

<script>
// Known Issues:
// Can't use `mask.lazy = true` (showing mask placeholder)
// since we are directly editing the model value

// import maskFieldValue from './lib/maskFieldValue.js'

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  }
}
</script>
